import { Route, Routes } from "react-router-dom";
import { PmsMainPage, PmsPromptConfigPage } from "./pages";
import { observer } from "mobx-react";

const PMSystemPage = observer(() => {
  return (
    <>    
      <Routes>
        <Route index element={<PmsMainPage />} />
        <Route path="config/:promptId/*" element={<PmsPromptConfigPage />} />
      </Routes>
    </>
  );
});

export default PMSystemPage;
